<template>
  <v-banner two-line>
    <v-avatar
      slot="icon"
      color="green"
      size="40"
    >
      <v-icon
        icon="mdi-lock"
        color="white"
      >
        mdi-check
      </v-icon>
    </v-avatar>
    Thank you. We have now whitelisted your IP, you will be redirect to the login page in 3 seconds
  </v-banner>
</template>

<script>
export default {
    mounted(){
        setTimeout(()=>{
            this.$router.push('/')
        }, 3000)
    }
}
</script>

<style>

</style>